import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { AuthProvider } from './context/AuthContext';

import { ThemeProvider } from './app/providers/ThemeProvider';
import { ThemeStyleBridge } from './app/providers/ThemeStyleBridge';
import './app/theme/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider>

      <ThemeStyleBridge />

      <AuthProvider>
        <App />
      </AuthProvider>

    </ThemeProvider>
  </React.StrictMode>
);
